import { render } from "./ProjectsDetailsPage.vue?vue&type=template&id=9a4c76ae"
import script from "./ProjectsDetailsPage.vue?vue&type=script&lang=js"
export * from "./ProjectsDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pavithram.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__